import React from 'react'

const SalesOrderForm = () => {
    return (
        <div>
            This is my sales order form!
        </div>
    )
}

export default SalesOrderForm
